exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-list[data-v-1d129eab]{background-color:#f0f0f0;height:100%}.user-list-container[data-v-1d129eab]{padding:20px;width:100%}.user-list-list-inactive-card[data-v-1d129eab]{display:inline-block;padding:4px 8px 6px;background:#fff;border-radius:8px;box-shadow:0 1px 4px rgba(0,0,0,.16);font-weight:500}", ""]);

// exports
